import { useCallback, useMemo } from "react";
import { GetNotifyNotificationStatus } from "../../../../../../queries/notify";
import { useInfiniteNotificationContent } from "../../../../hooks/useInfiniteNotificationContent";
import { useBreakpoint } from "./useBreakpoint";

export function useNotifyNotificationsCardInfiniteList({
  filters,
}: {
  filters: {
    query: string;
    subscriptionGroupIds: number[];
    departmentGroupId: number | null;
    status: GetNotifyNotificationStatus | null;
  };
}) {
  const {
    notifyContent,
    total,
    isNotificationContentFetching,
    fetchMoreNotificationContent,
    canFetchMoreNotificationContent,
  } = useInfiniteNotificationContent({
    take: 50,
    query: filters.query,
    subscriptionGroupIds: filters.subscriptionGroupIds,
    departmentGroupId: filters.departmentGroupId,
    status: filters.status,
  });

  const { lg } = useBreakpoint();
  const columnCount = lg ? 1 : 2;
  const notifyContent2D = useMemo(
    () => convertArrayInto2DArray(notifyContent, columnCount),
    [notifyContent, columnCount],
  );
  const total2D = Math.ceil(total / columnCount);

  const loadMoreRows = useCallback(async () => {
    if (!canFetchMoreNotificationContent || isNotificationContentFetching) return;
    await fetchMoreNotificationContent();
  }, [canFetchMoreNotificationContent, isNotificationContentFetching, fetchMoreNotificationContent]);

  const scrollElement = useMemo(() => document.querySelector("main") || window, []);

  return {
    notifyContent,
    total,
    notifyContent2D,
    total2D,
    isNotificationContentFetching,
    loadMoreRows,
    scrollElement,
    columnCount,
  };
}

function convertArrayInto2DArray(arr: any[], columns: number): any[][] {
  const result: any[][] = [];
  for (let i = 0; i < arr.length; i += columns) {
    result.push(arr.slice(i, i + columns));
  }
  return result;
}
